export const toDateString = (date: Date | string | null): string => {
  if (!date) {
    return '';
  }
  let theDate: Date;
  if (typeof date === "string") {
    theDate = new Date(date);
  } else {
    theDate = date;
  }
  if (!isNaN(theDate.getDate())) {
    return theDate.toISOString().substring(0, 10);
  }
  throw new Error("Invalid date cannot to be transformed into a date string");
}

export const displayDate = (date: Date|string|null) => {
  if (date === null) {
    return '-';
  }
  let theDate: Date;
  if (typeof date === "string") {
    theDate = new Date(date);
  } else {
    theDate = date;
  }
  
  if (!isNaN(theDate.getDate())) {
    return theDate.getDate().toString().padStart(2, '0') + '/' + (theDate.getMonth() + 1).toString().padStart(2, '0') + '/' + theDate.getFullYear()
  }
  throw new Error("Invalid date cannot to be transformed into a date string");
}